import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-3 overflow-auto" }
const _hoisted_2 = { class: "date" }

import {computed, inject, watch, onMounted, ref} from 'vue';
import ReactiveFilterableListOpenApiRequest from "~/core-ui/ts/request/ReactiveFilterableListOpenApiRequest";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import MyRemoteData from "~/cabinet/vue/interface/data/MyRemoteData.vue";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import ReactiveRequestPagination from "~/cabinet/vue/interface/pagination/ReactiveRequestPagination.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {Intervals} from "~/ts/library/delay/Intervals";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {__} from "~/ts/library/Translate";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {internationalUrlIfNeeded} from "~/core-ui/ts/Constants";
import {localeDateTimeString} from "~/core-ui/ts/CoreUiHelpersMixin";


const __default__ = {
    name: "OperatorApplicationNews"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let isSectionSelected = inject(isInSelectedSectionInjectionKey);

let isSectionSelectedOnce = ref(false);

let newsRequest = computed(() => {
    return (new ReactiveFilterableListOpenApiRequest(new OperatorApiRequest({
        url: "/news/getList",
        silent: true,
        silentError: true
    }))).setDefaultLimit(10).setCallback((data) => {
        let unreadedCount = (data as any as OperatorApplicationApi.OperatorGetNewsResultOpenApiModel).unreadedCount;
        if (OperatorAccountStore.unreadedNewsCount.value != unreadedCount) {
            if (unreadedCount > 0) {
                if (!isSectionSelected.value) {
                    let unreadedNews = (data as any as OperatorApplicationApi.OperatorGetNewsResultOpenApiModel).items.find(item => !item.isReaded);
                    if (unreadedNews) {
                        OperatorApplicationPlatformFactory.notifications.show({
                            groupId: "news",
                            title: __("Новости"),
                            text: unreadedNews.title,
                            click: () => {
                                OperatorApplicationRoutingStore.openNews();
                            }
                        });
                    }
                }
            }
        }
        OperatorAccountStore.SET_UNREADED_NEWS_COUNT((data as any as OperatorApplicationApi.OperatorGetNewsResultOpenApiModel).unreadedCount);
        markAsReaded();
    });
});

let newsList = computed(() => {
    return newsRequest.value.data ? newsRequest.value.data.items as any : [];
});

watch(isSectionSelected, () => {
    markAsReaded();
    if (isSectionSelected.value) {
        isSectionSelectedOnce.value = true;
    }
});

onMounted(() => {
    addDisposableEvent(Intervals.setDisposable(() => {
        if (!isSectionSelected.value) {
            newsRequest.value.make();
        }
    }, 3600 * 1000));
});

async function markAsReaded() {
    if (isSectionSelected.value) {
        let data: OperatorApplicationApi.OperatorGetNewsResultOpenApiModel = newsRequest.value.data as any;
        if (data) {
            let news: OperatorApplicationApi.OperatorNewsOpenApiModel[] = data.items;
            let unreaded = news
                .filter(item => !item.isReaded)
                .map(item => item.id);
            if (unreaded.length) {
                let p: OperatorApplicationApi.OperatorMarkNewsAsReadedOpenApiModel = {
                    idsList: unreaded
                };
                let result = await (new OperatorApiRequest({
                    url: "/news/markAsReaded",
                    p,
                    silent: true,
                    silentError: true
                })).send();
                if (result.isSuccess) {
                    let newCount = OperatorAccountStore.unreadedNewsCount.value - unreaded.length;
                    OperatorAccountStore.SET_UNREADED_NEWS_COUNT(newCount > 0 ? newCount : 0);
                }
            }
        }
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MyRemoteData, {
      request: _unref(newsRequest),
      "show-loading": "",
      style: {"max-width":"100%"},
      "default-limit": 10,
      class: "pb-4"
    }, {
      default: _withCtx(() => [
        (_unref(newsList) && _unref(isSectionSelectedOnce))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (news) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: news.id,
                  class: "news"
                }, [
                  _createElementVNode("h2", null, [
                    _createTextVNode(_toDisplayString(news.title) + " ", 1),
                    (!news.isReaded)
                      ? (_openBlock(), _createBlock(_component_el_badge, {
                          key: 0,
                          value: "New",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("   ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(localeDateTimeString)(news.dateTime)), 1),
                  _createVNode(OperatorApplicationHtmlify, {
                    escape: false,
                    "lightbox-img-tag": "",
                    value: _unref(internationalUrlIfNeeded)(news.content)
                  }, null, 8, ["value"])
                ]))
              }), 128)),
              _createVNode(ReactiveRequestPagination, {
                "list-request": _unref(newsRequest),
                class: "pb-3"
              }, null, 8, ["list-request"]),
              _cache[1] || (_cache[1] = _createElementVNode("div", null, " ", -1))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["request"])
  ]))
}
}

})